export const POSTHOG_EVENTS = {
  OFFER_SKIPPED: 'offer_skipped',
  OFFER_ADDED: 'offer_added',
  OFFER_VIEWED: 'offer_viewed',
  TOP_OFFERS_SHOWN: 'top_offers_shown',
  ALL_OFFERS_SKIPPED: 'all_offers_skipped',
  OFFER_PURCHASED: 'offer_purchased',
  OFFER_REMOVED_FROM_CART: 'offer_removed_from_cart',
  FREE_OFFERS_NAVIGATION: 'FREE_OFFERS_NAVIGATION',
  RECOMMENDATIONS_CLICKED: 'recommendations_clicked',
  OFFER_DETAIL_OPENED: 'offer_detail_opened',
  OFFER_MANUALLY_ADDED: 'offer_manually_added',
  OFFER_ADDED_TO_PAY_LATER: 'offer_added_to_pay_later',
  PARTNER_CLICKED: 'partner_clicked',
  INSTANT_CHECK_IN_STARTED: 'instant_check_in_started',
  INSTANT_CHECK_IN_FAILED: 'instant_check_in_failed',
  INSTANT_CHECK_IN_COMPLETED: 'instant_check_in_completed',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_ERROR: 'payment_error',
  PAYMENT_COMPLETED: 'payment_completed',
} as const;
